import React from 'react';

interface InfoTipProps {
  /** Accessible name of the icon, e.g. "Hjälp: så beskriver du en etapp". */
  label: string;
  children: React.ReactNode;
  /** Open the bubble from the icon's right edge (near the container's right side). */
  alignRight?: boolean;
  /** Keep the bubble within its positioned container, so it is not clipped on small screens. */
  fit?: boolean;
}

/**
 * The existing `.etappio-info-tip`: an info icon with a dark bubble that opens
 * on hover, keyboard focus and tap (focus-within). The bubble is placed
 * relative to the nearest positioned ancestor (`position-relative`).
 */
export function InfoTip({ label, children, alignRight = false, fit = false }: InfoTipProps) {
  const className = [
    'etappio-info-tip',
    alignRight ? 'etappio-info-tip--align-right' : '',
    fit ? 'etappio-info-tip--fit' : '',
  ].filter(Boolean).join(' ');
  return (
    <span className={className}>
      <i className="feather-info" tabIndex={0} role="button" aria-label={label}></i>
      <span className="etappio-info-tip__bubble" role="tooltip">{children}</span>
    </span>
  );
}
